module.exports = __webpack_public_path__ + "static/media/Jess-Wilson.30065da8.jpg";